import React, {useState} from "react";
import './style.css';
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import {Link} from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import {connect} from "react-redux";
import {Typography} from "@mui/material";
import plusIcon from '../../assets/img/15.png'
import minusIcon from '../../assets/img/17.png'
import Api from "../../utils/api";
import {toast} from "react-toastify";

const Sidebar = (props) => {

    const { authReducer, onClose } = props;
    const [expanded, setExpanded] = useState([]);

    const handleExpand = (id) => {

        let n_expanded = expanded;

        let array_index = -1;


        array_index = n_expanded.indexOf(id);
        if (array_index > -1) {
            n_expanded.splice(array_index, 1);
        } else {
            n_expanded.push(id);
        }

        setExpanded([...n_expanded]);
    }
    const handleCach = () => {
        new Api().get('/cache/clear').then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    return(
        <div className={'sidebar'} style={{ width: '300px',overflowX: "hidden"}}>
            <div className='top'>
                <Avatar title={authReducer.user.name} />
                <Typography color={"secondary"} variant={"button"} className='user-name'>{authReducer.user.name}</Typography>
                <Typography color={"secondary"} variant={"caption"} className='role'>{authReducer.user.role && authReducer.user.role.title}</Typography>
                <span className='circle'></span>
            </div>
            <div className={'menu-container'}>
                <ul>
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(6)}>
                        <img width={12} src={expanded.includes(6) ? minusIcon : plusIcon} />
                        <span>کاربران</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(6) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.user && +authReducer.user.permissions.user.get_users_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/users'}>کاربران</Link></li>}
                            {authReducer.user.permissions.user && +authReducer.user.permissions.user.get_roles_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/users/roles'}>نقش ها و سطوح دسترسی</Link></li>}
                            {authReducer.user.permissions.user && authReducer.user.permissions.user.get_users_log_admin && +authReducer.user.permissions.user.get_users_log_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/users/log'}>لاگ کاربران</Link></li>}
                            {authReducer.user.permissions.user && authReducer.user.permissions.user.get_users_log_admin && +authReducer.user.permissions.user.get_users_log_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/supplier'}>تامین کننده</Link></li>}
                        </ul>
                    </li>
                    <Divider />
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(0)}>
                        <img width={12} src={expanded.includes(0) ? minusIcon : plusIcon} />
                        <span>سفارشات و انبار</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(0) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.order && authReducer.user.permissions.order.get_orders_admin && +authReducer.user.permissions.order.get_orders_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/orders'}>لیست سفارشات</Link></li>}
                            {authReducer.user.permissions.order && authReducer.user.permissions.order.get_orders_admin && +authReducer.user.permissions.order.get_orders_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/orders/major'}> لیست سفارشات عمده</Link></li>}
                            {authReducer.user.permissions.depot && authReducer.user.permissions.depot.depot_index && +authReducer.user.permissions.depot.depot_index.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/depot'}>انبار</Link></li>}
                        </ul>
                    </li>
                    <Divider />
                    {authReducer.user.permissions.marketer && authReducer.user.permissions.marketer.get_marketers_admin && +authReducer.user.permissions.marketer.get_marketers_admin.access === 1 &&
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(1)}>
                        <img width={12} src={expanded.includes(1) ? minusIcon : plusIcon} />
                        <span>بازاریاب ها</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(1) ? 'block' : 'none'}}>
                            <li onClick={() => onClose()}><Link to={'/marketer'}>لیست</Link></li>
                            <li onClick={() => onClose()}><Link to={'/contracts/template'}>قالب قرارداد ها</Link></li>
                            <li onClick={() => onClose()}><Link to={'/contract'}>قرارداد ها</Link></li>
                            <li onClick={() => onClose()}><Link to={'/marketer/contract/commission/period'}>کمیسیون ها </Link></li>
                            <li onClick={() => onClose()}><Link to={'/marketer/contract/commission'}>قراراداد کمیسیون ها </Link></li>
                            <li onClick={() => onClose()}><Link to={'/reward'}>پاداش کلی</Link></li>
                        </ul>
                    </li>}
                    <Divider />
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(5)}>
                        <img width={12} src={expanded.includes(5) ? minusIcon : plusIcon} />
                        <span>دوره های زمانی</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(5) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.period && authReducer.user.permissions.period.get_period_admin && +authReducer.user.permissions.period.get_period_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/period'}>دوره ها</Link></li>}
                            {authReducer.user.permissions.period && authReducer.user.permissions.period.get_sales_daily_report_admin && authReducer.user.permissions.period.get_map_report_admin && +authReducer.user.permissions.period.get_sales_daily_report_admin.access === 1 && +authReducer.user.permissions.period.get_map_report_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/period/report'}>گزارش گیری</Link></li>}
                        </ul>
                    </li>
                    <Divider />
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(3)}>
                        <img width={12} src={expanded.includes(3) ? minusIcon : plusIcon} />
                        <span>محصولات</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(3) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.admin_get_product && +authReducer.user.permissions.product.admin_get_product.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product'}>محصولات</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.get_product_categories_admin && +authReducer.user.permissions.product.get_product_categories_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/major'}>محصولات عمده</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.get_product_categories_admin && +authReducer.user.permissions.product.get_product_categories_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product/category'}>دسته بندی محصولات</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.get_product_brands_admin && +authReducer.user.permissions.product.get_product_brands_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product/brand'}>برندها</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.admin_get_product && +authReducer.user.permissions.product.admin_get_product.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product/priceParameter'}>پارامترهای قیمتی</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.admin_get_product && +authReducer.user.permissions.product.admin_get_product.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product/filter'}>فیلترهای دلخواه</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.admin_get_product && +authReducer.user.permissions.product.admin_get_product.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/product/item'}>محصولات آیتمی</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.get_products_pins_admin && +authReducer.user.permissions.product.get_products_pins_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'product/pins'}>گزارش گیری محصولات</Link></li>}
                            {authReducer.user.permissions.product && authReducer.user.permissions.product.get_products_pins_admin && +authReducer.user.permissions.product.get_products_pins_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'product/attribute'}>افزودن ویژگی محصولات</Link></li>}
                        </ul>
                    </li>
                    <Divider />

                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(8)}>
                        <img width={12} src={expanded.includes(8) ? minusIcon : plusIcon} />
                        <span>مدیریت محتوا</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(8) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.blog && authReducer.user.permissions.blog.get_blog_admin && +authReducer.user.permissions.blog.get_blog_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/blog'}>مدیریت محتوا</Link></li>}
                            {authReducer.user.permissions.blog && authReducer.user.permissions.blog.get_blog_categories_admin && +authReducer.user.permissions.blog.get_blog_categories_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/blog/category'}>دسته بندی</Link></li>}
                            {authReducer.user.permissions.blog && authReducer.user.permissions.blog.get_blog_menu_admin && +authReducer.user.permissions.blog.get_blog_menu_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/menu'}>منوها</Link></li>}
                        </ul>
                    </li>
                    <Divider />
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(10)}>
                        <img width={12} src={expanded.includes(10) ? minusIcon : plusIcon} />
                        <span>کیف پول و مالی</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(10) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.finanical && authReducer.user.permissions.finanical.finance_group && +authReducer.user.permissions.finanical.finance_group.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/finance/group'}>لیست تجمیعی</Link></li>}
                            {authReducer.user.permissions.transaction && authReducer.user.permissions.transaction.get_transaction_admin && +authReducer.user.permissions.transaction.get_transaction_admin.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/transactions'}>تراکنش ها</Link></li>}
                            {authReducer.user.permissions.finanical && authReducer.user.permissions.finanical.finance_index && +authReducer.user.permissions.finanical.finance_index.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/finance'}>لیست جزئیات</Link></li>}
                        </ul>
                    </li>

                    <Divider />
                    <li className="tree-box">
                    <span className={'tree-parent has-child'} onClick={() => handleExpand(11)}>
                        <img width={12} src={expanded.includes(11) ? minusIcon : plusIcon} />
                        <span>سایر</span>
                    </span>
                        <ul className="tree-children" style={{ display: expanded.includes(11) ? 'block' : 'none'}}>
                            {authReducer.user.permissions.contact && authReducer.user.permissions.contact.get_content_admin && +authReducer.user.permissions.contact.get_content_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/region'}>مناطق</Link></li>}
                            {authReducer.user.permissions.contact && authReducer.user.permissions.contact.get_content_admin && +authReducer.user.permissions.contact.get_content_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/contactUs'}>تماس با ما</Link></li>}
                            {+authReducer.user.permissions?.setting?.get_setting_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/setting'}>تنظیمات</Link></li>}
                            {+authReducer.user.permissions?.setting?.get_setting_admin.access === 1 &&
                            <li onClick={() => onClose()}><Link to={'/sms'}>لیست پیامک ها</Link></li>}
                            {authReducer.user.permissions.notification && authReducer.user.permissions.notification.get_notification_admin && +authReducer.user.permissions.notification.get_notification_admin.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/notifications'}>صف ارسال و نوتیفیکیشن</Link></li>}
                            {authReducer.user.permissions.gallery && +authReducer.user.permissions.gallery.get_galleries_admin.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/gallery'}>اسلایدر و گالری تصاویر</Link></li>}
                            {authReducer.user.permissions.gallery && +authReducer.user.permissions.gallery.get_galleries_admin.access === 1 &&
                            <li className="tree-box" onClick={() => onClose()}><Link to={'/watermark'}>واترمارک</Link></li>}
                        </ul>
                    </li>
                    <Divider />
                    {authReducer.user.permissions.discount && +authReducer.user.permissions.discount.get_discount_codes.access === 1 &&
                    <li className="tree-box" onClick={() => onClose()}><Link to={'/discount'}>کد تخفیف </Link></li>}
                    <Divider/>
                    {authReducer.user.permissions.discount && +authReducer.user.permissions.discount.get_discount_codes.access === 1 &&
                    <li className="tree-box" onClick={() => onClose()}><Link to={'/comments'}>نظرات </Link></li>}
                    <Divider/>
                    <li className="tree-box">
                    <span style={{cursor:"pointer"}} className={'tree-parent has-child'} onClick={() => handleCach()}>
                        <span>بروزرسانی</span>
                    </span>
                    </li>
                </ul>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    authReducer: state.authReducer
})

export default connect(mapStateToProps)(Sidebar);
